<template>
    <div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <!-- <div class="col-md-6 col-lg-3">
                    <label>Date</label>
                    <datepicker v-model="currentDate"  name="currentDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div> -->
                  <div class="col-md-6 col-lg-3">
                    <label>CUSIP</label>
                    <input
                      style="height: 42px"
                      class="form-control"
                      v-model.trim="searchValue"
                    />
                  </div> 
                  <div class="col-md-6 col-lg-3">
                    <label>Status</label>
                     <multiselect 
                        v-model="status" 
                        placeholder="Select status" 
                        :options="statusList"  
                        :multiple="true" 
                        @input="search"
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <label>Ecn</label>
                     <multiselect 
                        v-model="ecn" 
                        placeholder="Select ecn" 
                        :options="['IBP','TWD','TMC']"  
                        :multiple="true" 
                        @input="search"
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <button @click="clear()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="search()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="abs-btn-grp form-group col-sm-4" style="justify-content: flex-end;">
            <form @submit.prevent="" class="d-inline-flex mt-0 ml-4">
              <h4 class="text-uppercase text-white mt-2 mr-2">Black box count : {{blackboxCount}}</h4>
              <div class="ims-tab">
                <button class="btn active" style="padding: 5px;" @click="reRunAll()" v-if="autoBidderBoxType === 'BLACK'|| autoBidderBoxType === 'GREY'">
                  <i  style="color: #0084cc;margin-top: 0px;" class="fa fa-redo"></i> Rerun
                </button>
              </div>
             
            </form>
          </div>
         
          <!-- <div class="abs-btn-grp form-group col-sm-3">
            <form @submit.prevent="" class="d-inline-flex mt-0 ml-4">
              <i @click="search()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
              <input v-on:keyup.enter="search" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
              <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
            </form>
          </div> -->
            <div class="row xsOnly">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl" style="min-height:125px">
                            <thead class="thead-light psticky">
                            <tr>
                                <th
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                                  @click="sort('cusip')">Cusip</th>
                                <th 
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'orderQty'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'orderQty'  ? 'sort-desc' : '']"  
                                  @click="sort('orderQty')">QTY</th>  
                                <th 
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ecn'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'ecn'  ? 'sort-desc' : '']"  
                                  @click="sort('ecn')">ECN</th> 
                                <th 
                                  scope="col" 
                                  class="sort text-center"
                                  v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                                  @click="sort('status')">STATUS</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidBy'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidBy'  ? 'sort-desc' : '']"  
                                    @click="sort('bidBy')">VALID UNTIL</th>  
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firmUntill'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firmUntill'  ? 'sort-desc' : '']"  
                                    @click="sort('firmUntill')">FIRM UNTIL</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settleDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'settleDate'  ? 'sort-desc' : '']"  
                                    @click="sort('settleDate')">SETTLEMENT DATE</th>   
                                    <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bondInsurer'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bondInsurer'  ? 'sort-desc' : '']"  
                                      @click="sort('bondInsurer')">BOND INSURER</th>
                                      <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipCoupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusipCoupon'  ? 'sort-desc' : '']"  
                                      @click="sort('cusipCoupon')">COUPON</th>
                                      <th 
                                      scope="col" 
                                      class="sort text-center"
                                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'stateName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'stateName'  ? 'sort-desc' : '']"  
                                      @click="sort('stateName')">STATE</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidPrice'  ? 'sort-desc' : '']"  
                                    @click="sort('bidPrice')"
                                    >PRICE</th>              
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>                     
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="bidwantedList.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in bidwantedList" :key="data.id">
                                <td class="text-center"><span class="cusips">{{data.cusip}}</span></td>
                                <td class="text-center">{{data.orderQty}}</td>
                                <td class="text-center">
                                    {{data.ecn}}
                                </td>
                                <td class="text-center">{{data.status}}</td>
                                <td class="text-center">{{data.bidBy ? moment.utc(data.bidBy).local().format("hh:mm:ss a") : 'N/A'}}</td>
                                <td class="text-center">{{data.firmUntill ? moment.utc(data.firmUntill).local().format("hh:mm:ss a") : 'N/A'}}</td>
                                <td class="text-center">{{data.settleDate ? moment(data.settleDate).format("MM/DD/YYYY"): 'N/A'}}</td>
                                <td class="text-center">
                                  {{ getAbbreviation(data.bondInsurer) }}
                                </td>
                                <td class="text-center">
                                  {{ data.cusipCoupon |  percent(3)  }}
                                </td>
                                <td class="text-center">
                                  {{ data.stateName }}
                                </td>
                                <td class="text-center">
                                  <input :disabled="data.status != 'BID_SENT'" min="0.001" step="0.001" oninput="validity.valid||(value='');"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="data.bidPrice">
                                </td>
                                <td class="text-center">
                                  <button v-if="data.status == 'BID_SENT'" :disabled="!data.bidPrice || !isBidExpired(data.bidBy)"  @click="updateBid(data)" class="btn btn-primary" type="button">
                                    <i class="fas fa-check"></i>UPDATE
                                  </button>
                                  <button v-if="data.status == 'BID_SENT'" :disabled="!isBidExpired(data.bidBy)"   @click="cancelBid(data)" class="btn btn-warning" type="button">
                                    <i class="fas fa-times"></i>CANCEL
                                  </button>
                                  <button v-if="data.status == 'BID_SENT' && (autoBidderBoxType === 'BLACK'|| autoBidderBoxType === 'GREY')" :disabled="!isBidExpired(data.bidBy)"   @click="reRun(data)" class="btn btn-info" type="button">
                                    <i class="fas fa-redo"></i>RERUN
                                  </button>
                                    
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getBidwantedList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <SendBidWanted v-bind:bidwanted="selectedBidWanted"  v-if="sendBidWantedModalOpen" @close="toggleSendBidWantedModal()" />
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import SendBidWanted from "../common/SendBidModal.vue";
// import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    SendBidWanted,
    // Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "id",
        sortOrder: "DESC",
        bidwantedList : [],
        createdDate : new Date(),
        showFilters : false,
        sendBidWantedModalOpen : false,
        selectedBidWanted : null,
        status : [],
        statusList : ["BID_SENDING","BID_SENT","ORDER_RECEIVED","ACCEPTED","REJECTED","TRADED_AWAY","SUBJECT","TRADE_CANCELLED","BID_CANCELLED","BID_CANCELING","DID_NOT_TRADE","APPROVAL_PENDING"],
        ecn : "",
        blackboxCount : 0,
        autoBidderBoxType : null,

       
    };
  },
  methods: {
    reRunAll(){
      var message = "Are you sure you want to rerun?";
        this.$confirm(message,"Rerun","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let dataToSend = {"autoBidBwIds":[] , "cognitoSub" : authService.getUser().cognitoSub}
          const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/cancel-rerun",dataToSend,
                    auth
                )
                .then(() => {
                  this.$alert("Rerun successfully started.", "", "success");
                  this.getBidwantedList();

                })
        });      

    },
    reRun(bid){
      var message = "Are you sure you want to rerun?";
        this.$confirm(message,"Rerun","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          let dataToSend = {"autoBidBwIds":[bid.id] , "cognitoSub" : authService.getUser().cognitoSub}
          const auth = {
                headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
                .post(
                config.baseUrlAutoBidder +
                    "/autobidder/cancel-rerun",dataToSend,
                    auth
                )
                .then(() => {
                  this.$alert("Rerun successfully started.", "", "success");
                  this.getBidwantedList();

                })
        });      

    },
    isBidExpired(validTime){
      var bidValidTime = this.moment(this.moment.utc(validTime).local().format("YYYY MM DD h:mma"), 'YYYY MM DD h:mma');
      var currentTime = this.moment(this.moment.utc().local().format("YYYY MM DD h:mma"), 'YYYY MM DD h:mma');
      if(bidValidTime.isAfter(currentTime) ){    
        return true;
      }else{
        return false;
      }

    },
    updateBid(bid){
      var message = "Are you sure you want to update?";
      this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "autoBidBwId":bid.id,
                  "price": bid.bidPrice,
                  "cognitoSub" : authService.getUser().cognitoSub
              }
          this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/update-bid",data,auth)
          .then(() => {
            this.loading = false;  
            this.$alert("Bid updated successfully","","success");            
            this.getBidwantedList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    },
    cancelBid(bid){
      var message = "Are you sure you want to cancel?";
      this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":bid.id,
                  "status":"CANCEL"
              }
          this.$http
          .put(config.baseUrlAutoBidder + "/autobidder/cancel-bid",data,auth)
          .then(() => {
            this.loading = false;  
            this.$alert("Bid cancelled successfully","","success");            
            this.getBidwantedList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    },
    toggleSendBidWantedModal(bid){
      if(bid)
      this.selectedBidWanted = bid;
      this.sendBidWantedModalOpen = !this.sendBidWantedModalOpen;
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getBidwantedList();
    },
    search(){
        this.currentPage = 1;
        this.getBidwantedList();  
    },
    clearSearch(){
        this.searchValue = "";
        this.currentPage = 1;
        this.getBidwantedList();  
    },
    clear(){
        this.searchValue = "";
        this.status = "";
        this.ecn = "";
        this.currentPage = 1;
        this.getBidwantedList();  
    },
    getUserSetting(){
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
          .get(
          config.baseUrlBidSide +
              "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
              auth
          )
          .then(result => {
              this.userSettings = result.data;
              this.userSettings.forEach(element => {
                if(element.setting == "AUTOBIDDER_BOX_TYPE"){
                  this.autoBidderBoxType = element.value;
                }
              });
              this.getBidwantedList();
          })
          .catch(e => {
              console.log(e);
          });
    },
    getBidwantedList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        let statusValue = this.status.length == 0 ? statusValue = this.statusList : this.status;
        
        // let currentDate = this.moment.utc().format("YYYY-MM-DD hh:mm:ss a")
        // let fromDate =  this.moment.utc(currentDate).format("YYYY-MM-DD hh:mm:ss");

        let currentDate = this.moment().format("MM-DD-YYYY");
        let fromDate = this.moment(currentDate).utc().format("YYYY-MM-DD HH:mm:ss")
        
        this.$http
        .get(
           config.baseUrlAutoBidder +
            "/autobidder/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            statusValue+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&userId="+
            authService.getUser().id+
            "&ecn="+
            this.ecn+
            // "&currentDate="+
            // currentDate+
            "&fromDate="+
            fromDate+
            "&loggedUser="+
            authService.getUser().id+
            "&cognitoSub="+
            authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.blackboxCount = result.data.pageInfo.otherInfo;
          this.bidwantedList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    }
   
  },
  mounted() {
    // this.getBidwantedList();
    this.getUserSetting();
    this.isBidExpired()
    this.$root.$on("bidwantedrefresh", () => {
        this.getBidwantedList();
    });
  },
  beforeDestroy() {
    this.$root.$off("bidwantedrefresh");
  }
};
</script>